<div class="red-circle" *ngIf="numberOfErrors">
  <div class="number">{{ numberOfErrors }}</div>
</div>
<div class="alerts-notification-button">
  <bell-button [transformCSS]="'scale(1.5)'"></bell-button>
</div>
